import { render, staticRenderFns } from "./applyDetails.vue?vue&type=template&id=287115d2&scoped=true&"
import script from "./applyDetails.vue?vue&type=script&lang=js&"
export * from "./applyDetails.vue?vue&type=script&lang=js&"
import style0 from "./applyDetails.vue?vue&type=style&index=0&id=287115d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287115d2",
  null
  
)

export default component.exports